import { useAuth } from "@src/contexts/AuthProvider";
import { useCreateCompanyToken } from "@src/pages/SuperAdmin/useCreateCompanyToken";
import React, { ReactElement, useEffect } from "react";
import { ErrorBoundary } from "@src/ErrorBoundary";

const query = new URLSearchParams(window.location.search);

export const MaybeSwitchCompany: React.FC<{
  children: ReactElement | null;
}> = ({ children }) => {
  const { createCompanyToken } = useCreateCompanyToken();
  const { updateCurrentUserState, tokenUserData } = useAuth();
  const [companyIdToUse, setCompanyIdToUse] = React.useState(
    query.get("useCompanyId"),
  );
  const [valid, setValid] = React.useState<boolean>();
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    async function fetchToken(useCompanyId: string) {
      setLoading(true);
      try {
        const { data: tokenData } = await createCompanyToken({
          variables: { companyId: useCompanyId },
        });

        if (tokenData?.createCompanyToken) {
          query.delete("useCompanyId");
          window.history.replaceState(
            {},
            document.title,
            `${document.location.pathname}?${query.toString()}`,
          );
          await updateCurrentUserState();
          setValid(true);
        } else {
          setValid(false);
        }
      } catch {
        setCompanyIdToUse(null);
        setValid(false);
      }
      setLoading(false);
    }

    if (
      companyIdToUse &&
      tokenUserData &&
      companyIdToUse !== tokenUserData.companyId
    ) {
      void fetchToken(companyIdToUse);
    } else if (companyIdToUse === tokenUserData?.companyId) {
      setValid(true);
    }
  }, [
    createCompanyToken,
    updateCurrentUserState,
    tokenUserData,
    companyIdToUse,
  ]);

  if (loading) {
    return <div>Loading...</div>;
  } else if (valid === false) {
    return (
      <ErrorBoundary
        hasError={true}
        message="Unable to find what you're looking for."
      />
    );
  } else {
    return children;
  }
};
